import React from 'react';
import {Col, Row} from "react-bootstrap";
import agent from "../../agent";
import "./Orgs.css"
import NewsBlock from "../Pollies/News/NewsContainer";
import CommentInput from './../Utils/OrgsSmallComments/CommentInput'
import OrgsSmallCommentContainer from "../Utils/OrgsSmallComments/OrgsSmallCommentContainer";
import {connect} from "react-redux";
import {orgsLoadComments} from '../../actions/OrgsComments'
import {getLabel} from "../../language";
import {fetchPollyNewsFinished} from "../../actions/pollypage";
import {Link} from "react-router-dom";
import PostAvatar from "../Post/PostAvatar";
import {Helmet} from "react-helmet";
import ChatModal from "../Pollies/ChatModal";
import Chat_icon from '../../images/Chat_icon.png';
import UserModal from "../AuthModal/index";

const mapStateToProps = state => ({
    commentsList: state.OrgsComments.comments || [],
    user: state.common.currentUser && state.common.currentUser.userName || "",
    anonymousMode: state.user.anonymousMode,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    getCommentList: dispatch(orgsLoadComments)
})

class OrgDetails extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            organization: {
                Name: "",
                Abbrevlation: "",
                OrganisationType: "",
                Hq_Street: "",
                Hq_Nr: "",
                Hq_PostalCode:"",
                Hq_City:"",
                Description_Short: "",
                Description_Long: "",
                Contact_Email: "",
                Website: "",
                Nr_Employees: "",
                Revenue: "",
                Profit: "",
                LogoName: "",
                AuthorAnonymous: true
            },
            logoSrc: "",
            comments: [],
            News: [],
            Orgs: [],
            showChat: false,
            isAuthModalOpen: false
        }
    }
  componentWillReceiveProps(nextProps) {
    const { Orgs } = nextProps
    const staticDescriptionElement = document.getElementById('main-description');
    if (staticDescriptionElement) {
      if(Orgs?.Description_Short) {
        staticDescriptionElement.remove();
      }
    }
  }

  componentWillUnmount() {
    const newStaticDescriptionElement = document.createElement('meta');
    newStaticDescriptionElement.id = 'main-description';
    newStaticDescriptionElement.name = 'description';
    newStaticDescriptionElement.content = 'A new social platform dedicated to politics. We\'re taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We\'re just getting started so this is just the beginning.';
    document.head.appendChild(newStaticDescriptionElement);
  }
    async componentDidMount() {
        const orgSlug = ((this.props.match || {}).params || {}).URLslug;

                let org = this.props.Orgs
                org.Name = this.props.Orgs.name
                org.Abbrevlation = this.props.Orgs.abbreviation
                org.OrganisationType = this.props.Orgs.organisationType
                org.Hq_Street = this.props.Orgs.headquarters_Street
                org.Hq_Nr = this.props.Orgs.headquarters_Nr

                org.Hq_PostalCode = this.props.Orgs.headquarters_PostalCode
                org.Hq_City = this.props.Orgs.headquarters_City
                org.Description_Short = this.props.Orgs.description_Short
                org.Description_Long = this.props.Orgs.description_Long
                org.Contact_Email = this.props.Orgs.contact_email
                org.Website = this.props.Orgs.website
                org.Nr_Employees = this.props.Orgs.nr_Employees
                org.Revenue = this.props.Orgs.revenue
                org.Profit = this.props.Orgs.profit
                org.LogoName = this.props.Orgs.logoName || ""
                org.AuthorAnonymous = this.props.Orgs.authorAnonymous
                this.getImage(this.props.Orgs.id);
                this.setState({
                    organization: org || this.state.organization
                });
                this.props.getCommentList(this.props.Orgs.id);

            await agent.Tags.getByName(orgSlug).then(res=>{
                if(res && res.length > 0) {
                  let tags = []
                  res.forEach(tag => {
                    tags.push(tag.id)
                  })
                  tags = tags.join(',')
                  agent.Pollies.getNewsList(tags).then(news=> {
                    if(news) {
                      this.setState({News: news})
                    }
                  })
                }
            }, err=>{})

            await agent.Organizations.getOrgs().then(res=>{
              if(res?.length){
                this.setState({Orgs:res||[]})
              }
            }, err=>{})

    }

  parseBody = body => {
    var matchedMentions = body.match(/\[~(.*?)\]/g);
    let content = body;
    if (matchedMentions && matchedMentions.length > 0) {
      matchedMentions.map(res => {
        const userName = res.match(/\[~(.*?)\]/).pop();
        const displayName = this.getDisplayNameFromMentions(userName);
        content = content.replace(res, `<a href=/@${userName}>${displayName}</a>`);
      })
    }
    return {__html: content};
  }

    getImage = async (id) => {

        await agent.Organizations.getOrgImage(id).then(res => {
            var reader = new window.FileReader();
            reader.readAsDataURL(res.xhr.response);
            reader.onloadend = () => {
                this.setState({
                    logoSrc: reader.result
                })
            }
        }, err => {
            this.setState({
                logoSrc: ""
            })
        })
    }

    toggleChat = () => {
        const { currentUser } = this.props;

        if (!currentUser) {
            this.setState({ isAuthModalOpen: true });
        } else {
            this.setState((prevState) => ({
                showChat: !prevState.showChat
            }));
        }
    };

    onCloseAuthModal = () => {
        this.setState({
            isAuthModalOpen: false
        });
    };

    render() {
        const { organization, logoSrc, News, showChat, isAuthModalOpen } = this.state;
        const { anonymousMode, currentUser } = this.props;
        return(
            <>
              <Helmet>
                <link rel="canonical" href={`${new URL(document.URL).origin}/${this.props?.Orgs?.urlslug}`}/>
                <title>{organization.Name}</title>
                <meta name="description" content={(organization.Description_Long || '').slice(0,150)}/>
              </Helmet>
            <div className={`organization${anonymousMode ? "-dark cw" : ""} p-20`}>
                <Row claasName="font-14">
                    <Col md={12}>
                        <hr/>
                    </Col>
                    <Col md={8}>
                        <Row>
                            <Col md={12}>
                                <h1 className={`${anonymousMode ? "cw" : ""}`}>{organization.Name || ""}</h1>
                            </Col>
                            <Col md={12}>
                                <label className="font-600 mb-0">Abbreviation</label>
                                <p>{organization.Abbrevlation || ""}</p>
                            </Col>
                            <Col md={6}>
                                <label className="font-600 mb-0">Type</label>
                                <p className="font-14">{organization.OrganisationType || ""}</p>
                            </Col>
                            <Col md={6}>
                                <label className="font-600 mb-0">Employees</label>
                                <p className="font-14">{organization.Nr_Employees || ""}</p>
                            </Col>
                            <Col md={4}>
                                <label className="font-600 mb-0">Website</label>
                                <p className="font-14">{organization.Website || ""}</p>
                            </Col>
                            <Col md={4}>
                                <label className="font-600 mb-0">Email</label>
                                <p className="font-14">{organization.Contact_Email || ""}</p>
                            </Col>
                            <Col md={4}>
                                <label className="font-600 mb-0">Revenue</label>
                                <p className="font-14">{organization.Revenue || ""}</p>
                            </Col>
                            <Col md={6}>
                                <label className="font-600 mb-0">Headquarters Address</label>
                                <p className="font-14">{organization.Hq_Street || ""}</p>
                            </Col>
                            <Col md={6}>
                                <label className="font-600 mb-0">Profit</label>
                                <p className="font-14">{organization.Profit || ""}</p>
                            </Col>
                          <Col md={6}>
                            <label className="font-600 mb-0">Description</label>
                            <p className="font-14">{organization.Description_Long || ""}</p>
                          </Col>
                        </Row>
                    </Col>

                    <Col md={4} className="text-right">
                        {
                            logoSrc ?
                                <div>
                                    <img width={200}
                                         // src={API_ROOT+'/'+organization.LogoName}
                                        src={logoSrc}
                                         alt="org"/>
                                </div> : null
                        }
                        {this.props.Orgs?.chat_status === "online" && (
                            <div className="mt-3">
                                <button
                                    onClick={this.toggleChat} 
                                    className={`btn ml-1 btn-default${anonymousMode ? "-dark" : ""} btn-polly-watch`}>
                                    <img src={Chat_icon} alt="Chat" className="w-24 pollypageImage"/> {getLabel(488)}
                                </button>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
            <Row className={'subfooter'}>
                <Col md={4}>
                    <div className={`politiqbox organization-bottom${anonymousMode ? "-dark" : ""} p-20`}>
                        <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(118)}</h3>
                        <CommentInput
                            replyComment={true}
                            userName={this.props?.user}
                            orgs={{id: organization.id}}
                            // isAvailableForReply={true}
                            replyMyPostsAndComments = {this.props.replyMyPostsAndComments}
                        />
                        <h4 className={`m-l-10 ${anonymousMode ? "cw" : ""}`}>Comments List</h4>
                            <OrgsSmallCommentContainer comments={this.props.commentsList} isAvailableForReply={false} />
                    </div>

                </Col>
                <Col md={4}>
                    <div className={`politiqbox organization-bottom${anonymousMode ? "-dark" : ""}  p-20`}>
                      <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(121)}</h3>
                        {this.state.News?.length ? this.state.News.map((item, i)=>{
                          return <div key={i} className="comment pointer">
                            <Link to={`/posts/${item.slug}`}>
                              <header>
                                <div className="authorimage"><a href="#">{item && <PostAvatar
                                  userName={item.authorUserName || item.author && item.author.userName || ''}/>}</a>
                                </div>
                                <div className="articletitle">
                                  <div className="text">
                                    <a style={{color: '#000000', fontWeight: 'lighter'}}>
                                      <div style={{fontSize: 13}}
                                           dangerouslySetInnerHTML={this.parseBody(item.body)}/>
                                    </a>
                                  </div>
                                </div>
                              </header>
                            </Link>
                            <div className="date hidden">{getLabel(122)}</div>
                          </div>
                        }):
                          <div>{getLabel(123)}</div>
                        }
                    </div>
                </Col>
                <Col md={4}>
                  <div className={`politiqbox organization-bottom${anonymousMode ? "-dark" : ""}  p-20`}>
                    <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(481)} </h3>
                    <div className=''>
                      {this.state.Orgs?.length ?
                        this.state.Orgs.map((item)=>{
                          return <Link className='d-block' to={item.urlslug}>{item.name}</Link>
                        })
                        : null}
                    </div>
                  </div>
                </Col>
            </Row>

            {/* Chat Modal */}
            {showChat && (
                <ChatModal
                    show={showChat}
                    onClose={this.toggleChat}
                    currentUser={currentUser}
                    polly={{
                        ...this.props.Orgs,
                        displayName: organization.Name,
                        typePage: "Organisation"
                    }}
                    displayLocation={currentUser?.displayLocation}
                    Name={currentUser?.displayName}
                />
            )}

            {/* Auth Modal */}
            <UserModal 
                isAuthModalOpen={isAuthModalOpen} 
                onCloseAuthModal={this.onCloseAuthModal} 
            />
        </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrgDetails);
